import translate from 'core/translate'
import { ContextMenuAction } from '../__canvas/templateEditor__contextMenu'

type LayerZOrderActions = {
    bringToFront: (id: string) => void
    sendToBack: (id: string) => void
    bringForward: (id: string) => void
    sendBackward: (id: string) => void
}

type LayerEditActions = {
    onDuplicate: () => void
    onDelete: () => void
}

export const buildLayerContextMenuGroups = (
    elementId: string,
    zOrder: LayerZOrderActions,
    edit: LayerEditActions
): ContextMenuAction[][] => [
    [
        {
            id: 'front',
            label: translate('templateEditorBringFront'),
            onClick: () => zOrder.bringToFront(elementId),
        },
        {
            id: 'forward',
            label: translate('templateEditorBringForward'),
            onClick: () => zOrder.bringForward(elementId),
        },
        {
            id: 'backward',
            label: translate('templateEditorSendBackward'),
            onClick: () => zOrder.sendBackward(elementId),
        },
        {
            id: 'back',
            label: translate('templateEditorSendBack'),
            onClick: () => zOrder.sendToBack(elementId),
        },
    ],
    [
        {
            id: 'duplicate',
            label: translate('templateEditorDuplicate'),
            onClick: edit.onDuplicate,
        },
        {
            id: 'delete',
            label: translate('delete'),
            danger: true,
            onClick: edit.onDelete,
        },
    ],
]
